// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: ir/uid/services/session_api.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { StringValue } from "../../../google/protobuf/wrappers";
import { CipherMethod, cipherMethodFromJSON, cipherMethodToJSON } from "../base/auth";
import { OtpTarget, Pair, RequestContext, ResponseContext } from "../base/base";
import { Device } from "../base/deviceinfo";
import { User } from "../external/base/user";

export const protobufPackage = "ir.uid.service";

export enum RedirectReason {
  REDIRECT_REASON_UNDEFINED = 0,
  REDIRECT_REASON_FINISHED_PROCESS = 1,
  REDIRECT_REASON_USER_CANCELLED_PROCESS = 2,
  REDIRECT_REASON_USER_CAMERA_NOT_ALLOWED = 3,
  REDIRECT_REASON_USER_CAMERA_NOT_DETECTED = 4,
  REDIRECT_REASON_USER_CANCELLED_PAYMENT = 5,
  UNRECOGNIZED = -1,
}

export function redirectReasonFromJSON(object: any): RedirectReason {
  switch (object) {
    case 0:
    case "REDIRECT_REASON_UNDEFINED":
      return RedirectReason.REDIRECT_REASON_UNDEFINED;
    case 1:
    case "REDIRECT_REASON_FINISHED_PROCESS":
      return RedirectReason.REDIRECT_REASON_FINISHED_PROCESS;
    case 2:
    case "REDIRECT_REASON_USER_CANCELLED_PROCESS":
      return RedirectReason.REDIRECT_REASON_USER_CANCELLED_PROCESS;
    case 3:
    case "REDIRECT_REASON_USER_CAMERA_NOT_ALLOWED":
      return RedirectReason.REDIRECT_REASON_USER_CAMERA_NOT_ALLOWED;
    case 4:
    case "REDIRECT_REASON_USER_CAMERA_NOT_DETECTED":
      return RedirectReason.REDIRECT_REASON_USER_CAMERA_NOT_DETECTED;
    case 5:
    case "REDIRECT_REASON_USER_CANCELLED_PAYMENT":
      return RedirectReason.REDIRECT_REASON_USER_CANCELLED_PAYMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RedirectReason.UNRECOGNIZED;
  }
}

export function redirectReasonToJSON(object: RedirectReason): string {
  switch (object) {
    case RedirectReason.REDIRECT_REASON_UNDEFINED:
      return "REDIRECT_REASON_UNDEFINED";
    case RedirectReason.REDIRECT_REASON_FINISHED_PROCESS:
      return "REDIRECT_REASON_FINISHED_PROCESS";
    case RedirectReason.REDIRECT_REASON_USER_CANCELLED_PROCESS:
      return "REDIRECT_REASON_USER_CANCELLED_PROCESS";
    case RedirectReason.REDIRECT_REASON_USER_CAMERA_NOT_ALLOWED:
      return "REDIRECT_REASON_USER_CAMERA_NOT_ALLOWED";
    case RedirectReason.REDIRECT_REASON_USER_CAMERA_NOT_DETECTED:
      return "REDIRECT_REASON_USER_CAMERA_NOT_DETECTED";
    case RedirectReason.REDIRECT_REASON_USER_CANCELLED_PAYMENT:
      return "REDIRECT_REASON_USER_CANCELLED_PAYMENT";
    case RedirectReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DivarMetaData {
  DIVAR_META_DATA_UNDEFINED = 0,
  DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON = 1,
  DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON = 2,
  DIVAR_META_DATA_POST_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON = 3,
  DIVAR_META_DATA_POST_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON = 4,
  UNRECOGNIZED = -1,
}

export function divarMetaDataFromJSON(object: any): DivarMetaData {
  switch (object) {
    case 0:
    case "DIVAR_META_DATA_UNDEFINED":
      return DivarMetaData.DIVAR_META_DATA_UNDEFINED;
    case 1:
    case "DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON":
      return DivarMetaData.DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON;
    case 2:
    case "DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON":
      return DivarMetaData.DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON;
    case 3:
    case "DIVAR_META_DATA_POST_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON":
      return DivarMetaData.DIVAR_META_DATA_POST_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON;
    case 4:
    case "DIVAR_META_DATA_POST_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON":
      return DivarMetaData.DIVAR_META_DATA_POST_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DivarMetaData.UNRECOGNIZED;
  }
}

export function divarMetaDataToJSON(object: DivarMetaData): string {
  switch (object) {
    case DivarMetaData.DIVAR_META_DATA_UNDEFINED:
      return "DIVAR_META_DATA_UNDEFINED";
    case DivarMetaData.DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON:
      return "DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON";
    case DivarMetaData.DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON:
      return "DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON";
    case DivarMetaData.DIVAR_META_DATA_POST_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON:
      return "DIVAR_META_DATA_POST_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON";
    case DivarMetaData.DIVAR_META_DATA_POST_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON:
      return "DIVAR_META_DATA_POST_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON";
    case DivarMetaData.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetRedirectUrlRequest {
  requestContext: RequestContext | undefined;
  reason: RedirectReason;
}

export interface GetRedirectUrlResponse {
  responseContext: ResponseContext | undefined;
  redirectUrl: string;
}

/**
 * this request is used in pwa landing page to create a session for each visit of the user
 * in case they do not convert into a proper user session due to issues with token,
 * signature,business-id or ....
 */
export interface GetPwaSessionRequest {
  requestContext: RequestContext | undefined;
  referrals: PwaReferral[];
  /**
   * in case of multiple visits to the landing page with different query parameters
   * sessionIdentifier for the previous PWA session would be sent here to allow backend
   * to update the session instead of creating a new one
   */
  sessionIdentifier:
    | string
    | undefined;
  /** todo: add platform information here */
  cookies: Pair[];
}

export interface GetPwaSessionResponse {
  responseContext:
    | ResponseContext
    | undefined;
  /** used to identify PWA sessions */
  sessionIdentifier: string | undefined;
}

export interface PwaReferral {
  /**
   * in case we can identify the referral name by specific query param patterns like AP
   * otherwise it would be left empty
   */
  referralName: string;
  /** token generated by business which would be sent in business-token query param to the PWA */
  referralToken: string;
  /**
   * meta data that business is going to use to identify their users by, it's an optional parameters
   * which will be received as business_meta_data
   */
  metaData: string;
  /** all the query parameters in the page */
  queryParams: Pair[];
  /** the original page address that redirected users to our PWA */
  referralURL:
    | string
    | undefined;
  /** the url that business want the user to be redirected to after successful or failed authorization */
  redirectUrl: string | undefined;
  businessId: string | undefined;
  referralSignature: string | undefined;
}

export interface GetBusinessWebLandingInformationRequest {
  requestContext:
    | RequestContext
    | undefined;
  /**
   * businessId is used to identify the referral with proper businessId to check signature
   * related to the business token and return URL and meta_data
   */
  businessId: string;
  /**
   * pwa session identifier that is acquired using the getPWASession
   * backend will use this identifier to find the appropriate referral to check signature with
   */
  pwaSessionIdentifier: string;
}

/**
 * in case of false businessId or wrong signature for query business parameters
 * a 401 equivalent response would be sent to the client in Response context with message
 * explaining roughly what the issue was.
 */
export interface GetBusinessWebLandingInformationResponse {
  responseContext:
    | ResponseContext
    | undefined;
  /** todo: add logo next action and requirements to the object */
  faq: string;
  /** the logo that would be shown in the PWA */
  businessLogo: string;
  styleConfig: string;
  /** todo: think of possible customization that we can have for each business in pwa */
  pageConfig: string;
}

export interface RequestOTPRequest {
  requestContext: RequestContext | undefined;
  target: OtpTarget | undefined;
}

export interface RequestOTPResponse {
  responseContext: ResponseContext | undefined;
  otpId: string;
}

export interface CheckOtpRequest {
  requestContext: RequestContext | undefined;
  otpId: string;
  otpCode: string;
}

export interface CheckOtpResponse {
  responseContext: ResponseContext | undefined;
}

export interface RegisterPwaUserSessionRequest {
  requestContext: RequestContext | undefined;
}

export interface RegisterUserSessionRequest {
  requestContext: RequestContext | undefined;
  user: User | undefined;
}

export interface RegisterUserSessionResponse {
  responseContext: ResponseContext | undefined;
}

export interface RegisterAppRequest {
  requestContext: RequestContext | undefined;
  appRegistrationToken: string;
  appSelfCheckHash: Uint8Array;
}

export interface RegisterAppResponse {
  requestContext: RequestContext | undefined;
}

export interface ChallengeRequest {
  requestContext: RequestContext | undefined;
  challengeResponse: Uint8Array;
}

export interface ChallengeResponse {
  responseContext: ResponseContext | undefined;
}

export interface SessionKeyExchangeRequest {
  /** *REQUIRED** Session and application associated data. */
  requestContext:
    | RequestContext
    | undefined;
  /** Device vendor identification. */
  deviceId: Uint8Array;
  /**
   * *REQUIRED** Ephemeral P-384 (secp384r1) public key generated by device encoded using ASN.1 in binary (DER) format.
   * This key will be be used for Diffie-Hellman key exchange (ECDH) on server and client.
   */
  publicKey: Uint8Array;
  /** Cipher algorithm for encrypting passwords. */
  cipherMethod: CipherMethod;
  device: Device | undefined;
}

export interface SessionKeyExchangeResponse {
  /** *REQUIRED** Status and response associated data. */
  responseContext:
    | ResponseContext
    | undefined;
  /**
   * P-384 (secp384r1) Ephemeral public key generated by server encoded using ASN.1 in binary (DER) format.
   * This key will be be used for Diffie-Hellman key exchange (ECDH) on server and client
   *
   * - Note: Client MUST store this key till session expires and must use this key to encrypt `Password`-type fields before sending on wire.
   */
  publicKey: Uint8Array;
  challengeToken: Uint8Array;
}

export interface KeycloakUserLoginRequest {
  requestContext: RequestContext | undefined;
  authCode: string;
  redirectUri: string;
}

export interface KeycloakUserLoginResponse {
  responseContext: ResponseContext | undefined;
  token: string;
  refreshToken: string;
}

export interface KeycloakUserLogoutRequest {
  requestContext: RequestContext | undefined;
  refreshToken: string;
}

export interface KeycloakUserLogoutResponse {
  responseContext: ResponseContext | undefined;
}

function createBaseGetRedirectUrlRequest(): GetRedirectUrlRequest {
  return { requestContext: undefined, reason: 0 };
}

export const GetRedirectUrlRequest = {
  encode(message: GetRedirectUrlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.reason !== 0) {
      writer.uint32(16).int32(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetRedirectUrlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRedirectUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRedirectUrlRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      reason: isSet(object.reason) ? redirectReasonFromJSON(object.reason) : 0,
    };
  },

  toJSON(message: GetRedirectUrlRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.reason !== 0) {
      obj.reason = redirectReasonToJSON(message.reason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRedirectUrlRequest>, I>>(base?: I): GetRedirectUrlRequest {
    return GetRedirectUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRedirectUrlRequest>, I>>(object: I): GetRedirectUrlRequest {
    const message = createBaseGetRedirectUrlRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.reason = object.reason ?? 0;
    return message;
  },
};

function createBaseGetRedirectUrlResponse(): GetRedirectUrlResponse {
  return { responseContext: undefined, redirectUrl: "" };
}

export const GetRedirectUrlResponse = {
  encode(message: GetRedirectUrlResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.redirectUrl !== "") {
      writer.uint32(18).string(message.redirectUrl);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetRedirectUrlResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRedirectUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.redirectUrl = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRedirectUrlResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
      redirectUrl: isSet(object.redirectUrl) ? globalThis.String(object.redirectUrl) : "",
    };
  },

  toJSON(message: GetRedirectUrlResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    if (message.redirectUrl !== "") {
      obj.redirectUrl = message.redirectUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRedirectUrlResponse>, I>>(base?: I): GetRedirectUrlResponse {
    return GetRedirectUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRedirectUrlResponse>, I>>(object: I): GetRedirectUrlResponse {
    const message = createBaseGetRedirectUrlResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    message.redirectUrl = object.redirectUrl ?? "";
    return message;
  },
};

function createBaseGetPwaSessionRequest(): GetPwaSessionRequest {
  return { requestContext: undefined, referrals: [], sessionIdentifier: undefined, cookies: [] };
}

export const GetPwaSessionRequest = {
  encode(message: GetPwaSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.referrals) {
      PwaReferral.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.sessionIdentifier !== undefined) {
      StringValue.encode({ value: message.sessionIdentifier! }, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.cookies) {
      Pair.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetPwaSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPwaSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.referrals.push(PwaReferral.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.sessionIdentifier = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.cookies.push(Pair.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPwaSessionRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      referrals: globalThis.Array.isArray(object?.referrals)
        ? object.referrals.map((e: any) => PwaReferral.fromJSON(e))
        : [],
      sessionIdentifier: isSet(object.sessionIdentifier) ? String(object.sessionIdentifier) : undefined,
      cookies: globalThis.Array.isArray(object?.cookies) ? object.cookies.map((e: any) => Pair.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetPwaSessionRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.referrals?.length) {
      obj.referrals = message.referrals.map((e) => PwaReferral.toJSON(e));
    }
    if (message.sessionIdentifier !== undefined) {
      obj.sessionIdentifier = message.sessionIdentifier;
    }
    if (message.cookies?.length) {
      obj.cookies = message.cookies.map((e) => Pair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPwaSessionRequest>, I>>(base?: I): GetPwaSessionRequest {
    return GetPwaSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPwaSessionRequest>, I>>(object: I): GetPwaSessionRequest {
    const message = createBaseGetPwaSessionRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.referrals = object.referrals?.map((e) => PwaReferral.fromPartial(e)) || [];
    message.sessionIdentifier = object.sessionIdentifier ?? undefined;
    message.cookies = object.cookies?.map((e) => Pair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetPwaSessionResponse(): GetPwaSessionResponse {
  return { responseContext: undefined, sessionIdentifier: undefined };
}

export const GetPwaSessionResponse = {
  encode(message: GetPwaSessionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.sessionIdentifier !== undefined) {
      StringValue.encode({ value: message.sessionIdentifier! }, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetPwaSessionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPwaSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.sessionIdentifier = StringValue.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPwaSessionResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
      sessionIdentifier: isSet(object.sessionIdentifier) ? String(object.sessionIdentifier) : undefined,
    };
  },

  toJSON(message: GetPwaSessionResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    if (message.sessionIdentifier !== undefined) {
      obj.sessionIdentifier = message.sessionIdentifier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPwaSessionResponse>, I>>(base?: I): GetPwaSessionResponse {
    return GetPwaSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPwaSessionResponse>, I>>(object: I): GetPwaSessionResponse {
    const message = createBaseGetPwaSessionResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    message.sessionIdentifier = object.sessionIdentifier ?? undefined;
    return message;
  },
};

function createBasePwaReferral(): PwaReferral {
  return {
    referralName: "",
    referralToken: "",
    metaData: "",
    queryParams: [],
    referralURL: undefined,
    redirectUrl: undefined,
    businessId: undefined,
    referralSignature: undefined,
  };
}

export const PwaReferral = {
  encode(message: PwaReferral, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.referralName !== "") {
      writer.uint32(10).string(message.referralName);
    }
    if (message.referralToken !== "") {
      writer.uint32(18).string(message.referralToken);
    }
    if (message.metaData !== "") {
      writer.uint32(26).string(message.metaData);
    }
    for (const v of message.queryParams) {
      Pair.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.referralURL !== undefined) {
      StringValue.encode({ value: message.referralURL! }, writer.uint32(42).fork()).ldelim();
    }
    if (message.redirectUrl !== undefined) {
      StringValue.encode({ value: message.redirectUrl! }, writer.uint32(50).fork()).ldelim();
    }
    if (message.businessId !== undefined) {
      StringValue.encode({ value: message.businessId! }, writer.uint32(58).fork()).ldelim();
    }
    if (message.referralSignature !== undefined) {
      StringValue.encode({ value: message.referralSignature! }, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PwaReferral {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePwaReferral();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.referralName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.referralToken = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.metaData = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.queryParams.push(Pair.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.referralURL = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.redirectUrl = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.businessId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.referralSignature = StringValue.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PwaReferral {
    return {
      referralName: isSet(object.referralName) ? globalThis.String(object.referralName) : "",
      referralToken: isSet(object.referralToken) ? globalThis.String(object.referralToken) : "",
      metaData: isSet(object.metaData) ? globalThis.String(object.metaData) : "",
      queryParams: globalThis.Array.isArray(object?.queryParams)
        ? object.queryParams.map((e: any) => Pair.fromJSON(e))
        : [],
      referralURL: isSet(object.referralURL) ? String(object.referralURL) : undefined,
      redirectUrl: isSet(object.redirectUrl) ? String(object.redirectUrl) : undefined,
      businessId: isSet(object.businessId) ? String(object.businessId) : undefined,
      referralSignature: isSet(object.referralSignature) ? String(object.referralSignature) : undefined,
    };
  },

  toJSON(message: PwaReferral): unknown {
    const obj: any = {};
    if (message.referralName !== "") {
      obj.referralName = message.referralName;
    }
    if (message.referralToken !== "") {
      obj.referralToken = message.referralToken;
    }
    if (message.metaData !== "") {
      obj.metaData = message.metaData;
    }
    if (message.queryParams?.length) {
      obj.queryParams = message.queryParams.map((e) => Pair.toJSON(e));
    }
    if (message.referralURL !== undefined) {
      obj.referralURL = message.referralURL;
    }
    if (message.redirectUrl !== undefined) {
      obj.redirectUrl = message.redirectUrl;
    }
    if (message.businessId !== undefined) {
      obj.businessId = message.businessId;
    }
    if (message.referralSignature !== undefined) {
      obj.referralSignature = message.referralSignature;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PwaReferral>, I>>(base?: I): PwaReferral {
    return PwaReferral.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PwaReferral>, I>>(object: I): PwaReferral {
    const message = createBasePwaReferral();
    message.referralName = object.referralName ?? "";
    message.referralToken = object.referralToken ?? "";
    message.metaData = object.metaData ?? "";
    message.queryParams = object.queryParams?.map((e) => Pair.fromPartial(e)) || [];
    message.referralURL = object.referralURL ?? undefined;
    message.redirectUrl = object.redirectUrl ?? undefined;
    message.businessId = object.businessId ?? undefined;
    message.referralSignature = object.referralSignature ?? undefined;
    return message;
  },
};

function createBaseGetBusinessWebLandingInformationRequest(): GetBusinessWebLandingInformationRequest {
  return { requestContext: undefined, businessId: "", pwaSessionIdentifier: "" };
}

export const GetBusinessWebLandingInformationRequest = {
  encode(message: GetBusinessWebLandingInformationRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.businessId !== "") {
      writer.uint32(18).string(message.businessId);
    }
    if (message.pwaSessionIdentifier !== "") {
      writer.uint32(26).string(message.pwaSessionIdentifier);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetBusinessWebLandingInformationRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBusinessWebLandingInformationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.businessId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pwaSessionIdentifier = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBusinessWebLandingInformationRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      businessId: isSet(object.businessId) ? globalThis.String(object.businessId) : "",
      pwaSessionIdentifier: isSet(object.pwaSessionIdentifier) ? globalThis.String(object.pwaSessionIdentifier) : "",
    };
  },

  toJSON(message: GetBusinessWebLandingInformationRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.businessId !== "") {
      obj.businessId = message.businessId;
    }
    if (message.pwaSessionIdentifier !== "") {
      obj.pwaSessionIdentifier = message.pwaSessionIdentifier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBusinessWebLandingInformationRequest>, I>>(
    base?: I,
  ): GetBusinessWebLandingInformationRequest {
    return GetBusinessWebLandingInformationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBusinessWebLandingInformationRequest>, I>>(
    object: I,
  ): GetBusinessWebLandingInformationRequest {
    const message = createBaseGetBusinessWebLandingInformationRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.businessId = object.businessId ?? "";
    message.pwaSessionIdentifier = object.pwaSessionIdentifier ?? "";
    return message;
  },
};

function createBaseGetBusinessWebLandingInformationResponse(): GetBusinessWebLandingInformationResponse {
  return { responseContext: undefined, faq: "", businessLogo: "", styleConfig: "", pageConfig: "" };
}

export const GetBusinessWebLandingInformationResponse = {
  encode(message: GetBusinessWebLandingInformationResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.faq !== "") {
      writer.uint32(18).string(message.faq);
    }
    if (message.businessLogo !== "") {
      writer.uint32(26).string(message.businessLogo);
    }
    if (message.styleConfig !== "") {
      writer.uint32(34).string(message.styleConfig);
    }
    if (message.pageConfig !== "") {
      writer.uint32(42).string(message.pageConfig);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetBusinessWebLandingInformationResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBusinessWebLandingInformationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.faq = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.businessLogo = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.styleConfig = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.pageConfig = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBusinessWebLandingInformationResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
      faq: isSet(object.faq) ? globalThis.String(object.faq) : "",
      businessLogo: isSet(object.businessLogo) ? globalThis.String(object.businessLogo) : "",
      styleConfig: isSet(object.styleConfig) ? globalThis.String(object.styleConfig) : "",
      pageConfig: isSet(object.pageConfig) ? globalThis.String(object.pageConfig) : "",
    };
  },

  toJSON(message: GetBusinessWebLandingInformationResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    if (message.faq !== "") {
      obj.faq = message.faq;
    }
    if (message.businessLogo !== "") {
      obj.businessLogo = message.businessLogo;
    }
    if (message.styleConfig !== "") {
      obj.styleConfig = message.styleConfig;
    }
    if (message.pageConfig !== "") {
      obj.pageConfig = message.pageConfig;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBusinessWebLandingInformationResponse>, I>>(
    base?: I,
  ): GetBusinessWebLandingInformationResponse {
    return GetBusinessWebLandingInformationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBusinessWebLandingInformationResponse>, I>>(
    object: I,
  ): GetBusinessWebLandingInformationResponse {
    const message = createBaseGetBusinessWebLandingInformationResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    message.faq = object.faq ?? "";
    message.businessLogo = object.businessLogo ?? "";
    message.styleConfig = object.styleConfig ?? "";
    message.pageConfig = object.pageConfig ?? "";
    return message;
  },
};

function createBaseRequestOTPRequest(): RequestOTPRequest {
  return { requestContext: undefined, target: undefined };
}

export const RequestOTPRequest = {
  encode(message: RequestOTPRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.target !== undefined) {
      OtpTarget.encode(message.target, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestOTPRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestOTPRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.target = OtpTarget.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestOTPRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      target: isSet(object.target) ? OtpTarget.fromJSON(object.target) : undefined,
    };
  },

  toJSON(message: RequestOTPRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.target !== undefined) {
      obj.target = OtpTarget.toJSON(message.target);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestOTPRequest>, I>>(base?: I): RequestOTPRequest {
    return RequestOTPRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestOTPRequest>, I>>(object: I): RequestOTPRequest {
    const message = createBaseRequestOTPRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.target = (object.target !== undefined && object.target !== null)
      ? OtpTarget.fromPartial(object.target)
      : undefined;
    return message;
  },
};

function createBaseRequestOTPResponse(): RequestOTPResponse {
  return { responseContext: undefined, otpId: "" };
}

export const RequestOTPResponse = {
  encode(message: RequestOTPResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.otpId !== "") {
      writer.uint32(18).string(message.otpId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestOTPResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestOTPResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.otpId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestOTPResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
      otpId: isSet(object.otpId) ? globalThis.String(object.otpId) : "",
    };
  },

  toJSON(message: RequestOTPResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    if (message.otpId !== "") {
      obj.otpId = message.otpId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestOTPResponse>, I>>(base?: I): RequestOTPResponse {
    return RequestOTPResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestOTPResponse>, I>>(object: I): RequestOTPResponse {
    const message = createBaseRequestOTPResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    message.otpId = object.otpId ?? "";
    return message;
  },
};

function createBaseCheckOtpRequest(): CheckOtpRequest {
  return { requestContext: undefined, otpId: "", otpCode: "" };
}

export const CheckOtpRequest = {
  encode(message: CheckOtpRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.otpId !== "") {
      writer.uint32(18).string(message.otpId);
    }
    if (message.otpCode !== "") {
      writer.uint32(26).string(message.otpCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CheckOtpRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckOtpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.otpId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.otpCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckOtpRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      otpId: isSet(object.otpId) ? globalThis.String(object.otpId) : "",
      otpCode: isSet(object.otpCode) ? globalThis.String(object.otpCode) : "",
    };
  },

  toJSON(message: CheckOtpRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.otpId !== "") {
      obj.otpId = message.otpId;
    }
    if (message.otpCode !== "") {
      obj.otpCode = message.otpCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckOtpRequest>, I>>(base?: I): CheckOtpRequest {
    return CheckOtpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckOtpRequest>, I>>(object: I): CheckOtpRequest {
    const message = createBaseCheckOtpRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.otpId = object.otpId ?? "";
    message.otpCode = object.otpCode ?? "";
    return message;
  },
};

function createBaseCheckOtpResponse(): CheckOtpResponse {
  return { responseContext: undefined };
}

export const CheckOtpResponse = {
  encode(message: CheckOtpResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CheckOtpResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckOtpResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckOtpResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
    };
  },

  toJSON(message: CheckOtpResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckOtpResponse>, I>>(base?: I): CheckOtpResponse {
    return CheckOtpResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckOtpResponse>, I>>(object: I): CheckOtpResponse {
    const message = createBaseCheckOtpResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    return message;
  },
};

function createBaseRegisterPwaUserSessionRequest(): RegisterPwaUserSessionRequest {
  return { requestContext: undefined };
}

export const RegisterPwaUserSessionRequest = {
  encode(message: RegisterPwaUserSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterPwaUserSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterPwaUserSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterPwaUserSessionRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
    };
  },

  toJSON(message: RegisterPwaUserSessionRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterPwaUserSessionRequest>, I>>(base?: I): RegisterPwaUserSessionRequest {
    return RegisterPwaUserSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterPwaUserSessionRequest>, I>>(
    object: I,
  ): RegisterPwaUserSessionRequest {
    const message = createBaseRegisterPwaUserSessionRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    return message;
  },
};

function createBaseRegisterUserSessionRequest(): RegisterUserSessionRequest {
  return { requestContext: undefined, user: undefined };
}

export const RegisterUserSessionRequest = {
  encode(message: RegisterUserSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterUserSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterUserSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterUserSessionRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: RegisterUserSessionRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterUserSessionRequest>, I>>(base?: I): RegisterUserSessionRequest {
    return RegisterUserSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterUserSessionRequest>, I>>(object: I): RegisterUserSessionRequest {
    const message = createBaseRegisterUserSessionRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseRegisterUserSessionResponse(): RegisterUserSessionResponse {
  return { responseContext: undefined };
}

export const RegisterUserSessionResponse = {
  encode(message: RegisterUserSessionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterUserSessionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterUserSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterUserSessionResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
    };
  },

  toJSON(message: RegisterUserSessionResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterUserSessionResponse>, I>>(base?: I): RegisterUserSessionResponse {
    return RegisterUserSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterUserSessionResponse>, I>>(object: I): RegisterUserSessionResponse {
    const message = createBaseRegisterUserSessionResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    return message;
  },
};

function createBaseRegisterAppRequest(): RegisterAppRequest {
  return { requestContext: undefined, appRegistrationToken: "", appSelfCheckHash: new Uint8Array(0) };
}

export const RegisterAppRequest = {
  encode(message: RegisterAppRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.appRegistrationToken !== "") {
      writer.uint32(18).string(message.appRegistrationToken);
    }
    if (message.appSelfCheckHash.length !== 0) {
      writer.uint32(26).bytes(message.appSelfCheckHash);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterAppRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterAppRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.appRegistrationToken = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.appSelfCheckHash = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterAppRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      appRegistrationToken: isSet(object.appRegistrationToken) ? globalThis.String(object.appRegistrationToken) : "",
      appSelfCheckHash: isSet(object.appSelfCheckHash) ? bytesFromBase64(object.appSelfCheckHash) : new Uint8Array(0),
    };
  },

  toJSON(message: RegisterAppRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.appRegistrationToken !== "") {
      obj.appRegistrationToken = message.appRegistrationToken;
    }
    if (message.appSelfCheckHash.length !== 0) {
      obj.appSelfCheckHash = base64FromBytes(message.appSelfCheckHash);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterAppRequest>, I>>(base?: I): RegisterAppRequest {
    return RegisterAppRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterAppRequest>, I>>(object: I): RegisterAppRequest {
    const message = createBaseRegisterAppRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.appRegistrationToken = object.appRegistrationToken ?? "";
    message.appSelfCheckHash = object.appSelfCheckHash ?? new Uint8Array(0);
    return message;
  },
};

function createBaseRegisterAppResponse(): RegisterAppResponse {
  return { requestContext: undefined };
}

export const RegisterAppResponse = {
  encode(message: RegisterAppResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterAppResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterAppResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterAppResponse {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
    };
  },

  toJSON(message: RegisterAppResponse): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterAppResponse>, I>>(base?: I): RegisterAppResponse {
    return RegisterAppResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterAppResponse>, I>>(object: I): RegisterAppResponse {
    const message = createBaseRegisterAppResponse();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    return message;
  },
};

function createBaseChallengeRequest(): ChallengeRequest {
  return { requestContext: undefined, challengeResponse: new Uint8Array(0) };
}

export const ChallengeRequest = {
  encode(message: ChallengeRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.challengeResponse.length !== 0) {
      writer.uint32(18).bytes(message.challengeResponse);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChallengeRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChallengeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.challengeResponse = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChallengeRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      challengeResponse: isSet(object.challengeResponse)
        ? bytesFromBase64(object.challengeResponse)
        : new Uint8Array(0),
    };
  },

  toJSON(message: ChallengeRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.challengeResponse.length !== 0) {
      obj.challengeResponse = base64FromBytes(message.challengeResponse);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChallengeRequest>, I>>(base?: I): ChallengeRequest {
    return ChallengeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChallengeRequest>, I>>(object: I): ChallengeRequest {
    const message = createBaseChallengeRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.challengeResponse = object.challengeResponse ?? new Uint8Array(0);
    return message;
  },
};

function createBaseChallengeResponse(): ChallengeResponse {
  return { responseContext: undefined };
}

export const ChallengeResponse = {
  encode(message: ChallengeResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChallengeResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChallengeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChallengeResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
    };
  },

  toJSON(message: ChallengeResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChallengeResponse>, I>>(base?: I): ChallengeResponse {
    return ChallengeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChallengeResponse>, I>>(object: I): ChallengeResponse {
    const message = createBaseChallengeResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    return message;
  },
};

function createBaseSessionKeyExchangeRequest(): SessionKeyExchangeRequest {
  return {
    requestContext: undefined,
    deviceId: new Uint8Array(0),
    publicKey: new Uint8Array(0),
    cipherMethod: 0,
    device: undefined,
  };
}

export const SessionKeyExchangeRequest = {
  encode(message: SessionKeyExchangeRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.deviceId.length !== 0) {
      writer.uint32(18).bytes(message.deviceId);
    }
    if (message.publicKey.length !== 0) {
      writer.uint32(26).bytes(message.publicKey);
    }
    if (message.cipherMethod !== 0) {
      writer.uint32(32).int32(message.cipherMethod);
    }
    if (message.device !== undefined) {
      Device.encode(message.device, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SessionKeyExchangeRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSessionKeyExchangeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.publicKey = reader.bytes();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.cipherMethod = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.device = Device.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SessionKeyExchangeRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      deviceId: isSet(object.deviceId) ? bytesFromBase64(object.deviceId) : new Uint8Array(0),
      publicKey: isSet(object.publicKey) ? bytesFromBase64(object.publicKey) : new Uint8Array(0),
      cipherMethod: isSet(object.cipherMethod) ? cipherMethodFromJSON(object.cipherMethod) : 0,
      device: isSet(object.device) ? Device.fromJSON(object.device) : undefined,
    };
  },

  toJSON(message: SessionKeyExchangeRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.deviceId.length !== 0) {
      obj.deviceId = base64FromBytes(message.deviceId);
    }
    if (message.publicKey.length !== 0) {
      obj.publicKey = base64FromBytes(message.publicKey);
    }
    if (message.cipherMethod !== 0) {
      obj.cipherMethod = cipherMethodToJSON(message.cipherMethod);
    }
    if (message.device !== undefined) {
      obj.device = Device.toJSON(message.device);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SessionKeyExchangeRequest>, I>>(base?: I): SessionKeyExchangeRequest {
    return SessionKeyExchangeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SessionKeyExchangeRequest>, I>>(object: I): SessionKeyExchangeRequest {
    const message = createBaseSessionKeyExchangeRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.deviceId = object.deviceId ?? new Uint8Array(0);
    message.publicKey = object.publicKey ?? new Uint8Array(0);
    message.cipherMethod = object.cipherMethod ?? 0;
    message.device = (object.device !== undefined && object.device !== null)
      ? Device.fromPartial(object.device)
      : undefined;
    return message;
  },
};

function createBaseSessionKeyExchangeResponse(): SessionKeyExchangeResponse {
  return { responseContext: undefined, publicKey: new Uint8Array(0), challengeToken: new Uint8Array(0) };
}

export const SessionKeyExchangeResponse = {
  encode(message: SessionKeyExchangeResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.publicKey.length !== 0) {
      writer.uint32(26).bytes(message.publicKey);
    }
    if (message.challengeToken.length !== 0) {
      writer.uint32(34).bytes(message.challengeToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SessionKeyExchangeResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSessionKeyExchangeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.publicKey = reader.bytes();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.challengeToken = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SessionKeyExchangeResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
      publicKey: isSet(object.publicKey) ? bytesFromBase64(object.publicKey) : new Uint8Array(0),
      challengeToken: isSet(object.challengeToken) ? bytesFromBase64(object.challengeToken) : new Uint8Array(0),
    };
  },

  toJSON(message: SessionKeyExchangeResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    if (message.publicKey.length !== 0) {
      obj.publicKey = base64FromBytes(message.publicKey);
    }
    if (message.challengeToken.length !== 0) {
      obj.challengeToken = base64FromBytes(message.challengeToken);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SessionKeyExchangeResponse>, I>>(base?: I): SessionKeyExchangeResponse {
    return SessionKeyExchangeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SessionKeyExchangeResponse>, I>>(object: I): SessionKeyExchangeResponse {
    const message = createBaseSessionKeyExchangeResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    message.publicKey = object.publicKey ?? new Uint8Array(0);
    message.challengeToken = object.challengeToken ?? new Uint8Array(0);
    return message;
  },
};

function createBaseKeycloakUserLoginRequest(): KeycloakUserLoginRequest {
  return { requestContext: undefined, authCode: "", redirectUri: "" };
}

export const KeycloakUserLoginRequest = {
  encode(message: KeycloakUserLoginRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.authCode !== "") {
      writer.uint32(18).string(message.authCode);
    }
    if (message.redirectUri !== "") {
      writer.uint32(26).string(message.redirectUri);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeycloakUserLoginRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeycloakUserLoginRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.authCode = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.redirectUri = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeycloakUserLoginRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      authCode: isSet(object.authCode) ? globalThis.String(object.authCode) : "",
      redirectUri: isSet(object.redirectUri) ? globalThis.String(object.redirectUri) : "",
    };
  },

  toJSON(message: KeycloakUserLoginRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.authCode !== "") {
      obj.authCode = message.authCode;
    }
    if (message.redirectUri !== "") {
      obj.redirectUri = message.redirectUri;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeycloakUserLoginRequest>, I>>(base?: I): KeycloakUserLoginRequest {
    return KeycloakUserLoginRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeycloakUserLoginRequest>, I>>(object: I): KeycloakUserLoginRequest {
    const message = createBaseKeycloakUserLoginRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.authCode = object.authCode ?? "";
    message.redirectUri = object.redirectUri ?? "";
    return message;
  },
};

function createBaseKeycloakUserLoginResponse(): KeycloakUserLoginResponse {
  return { responseContext: undefined, token: "", refreshToken: "" };
}

export const KeycloakUserLoginResponse = {
  encode(message: KeycloakUserLoginResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.token !== "") {
      writer.uint32(18).string(message.token);
    }
    if (message.refreshToken !== "") {
      writer.uint32(26).string(message.refreshToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeycloakUserLoginResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeycloakUserLoginResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.token = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.refreshToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeycloakUserLoginResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      refreshToken: isSet(object.refreshToken) ? globalThis.String(object.refreshToken) : "",
    };
  },

  toJSON(message: KeycloakUserLoginResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    if (message.token !== "") {
      obj.token = message.token;
    }
    if (message.refreshToken !== "") {
      obj.refreshToken = message.refreshToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeycloakUserLoginResponse>, I>>(base?: I): KeycloakUserLoginResponse {
    return KeycloakUserLoginResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeycloakUserLoginResponse>, I>>(object: I): KeycloakUserLoginResponse {
    const message = createBaseKeycloakUserLoginResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    message.token = object.token ?? "";
    message.refreshToken = object.refreshToken ?? "";
    return message;
  },
};

function createBaseKeycloakUserLogoutRequest(): KeycloakUserLogoutRequest {
  return { requestContext: undefined, refreshToken: "" };
}

export const KeycloakUserLogoutRequest = {
  encode(message: KeycloakUserLogoutRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestContext !== undefined) {
      RequestContext.encode(message.requestContext, writer.uint32(10).fork()).ldelim();
    }
    if (message.refreshToken !== "") {
      writer.uint32(18).string(message.refreshToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeycloakUserLogoutRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeycloakUserLogoutRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestContext = RequestContext.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.refreshToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeycloakUserLogoutRequest {
    return {
      requestContext: isSet(object.requestContext) ? RequestContext.fromJSON(object.requestContext) : undefined,
      refreshToken: isSet(object.refreshToken) ? globalThis.String(object.refreshToken) : "",
    };
  },

  toJSON(message: KeycloakUserLogoutRequest): unknown {
    const obj: any = {};
    if (message.requestContext !== undefined) {
      obj.requestContext = RequestContext.toJSON(message.requestContext);
    }
    if (message.refreshToken !== "") {
      obj.refreshToken = message.refreshToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeycloakUserLogoutRequest>, I>>(base?: I): KeycloakUserLogoutRequest {
    return KeycloakUserLogoutRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeycloakUserLogoutRequest>, I>>(object: I): KeycloakUserLogoutRequest {
    const message = createBaseKeycloakUserLogoutRequest();
    message.requestContext = (object.requestContext !== undefined && object.requestContext !== null)
      ? RequestContext.fromPartial(object.requestContext)
      : undefined;
    message.refreshToken = object.refreshToken ?? "";
    return message;
  },
};

function createBaseKeycloakUserLogoutResponse(): KeycloakUserLogoutResponse {
  return { responseContext: undefined };
}

export const KeycloakUserLogoutResponse = {
  encode(message: KeycloakUserLogoutResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeycloakUserLogoutResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeycloakUserLogoutResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeycloakUserLogoutResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
    };
  },

  toJSON(message: KeycloakUserLogoutResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeycloakUserLogoutResponse>, I>>(base?: I): KeycloakUserLogoutResponse {
    return KeycloakUserLogoutResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeycloakUserLogoutResponse>, I>>(object: I): KeycloakUserLogoutResponse {
    const message = createBaseKeycloakUserLogoutResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    return message;
  },
};

export interface SessionService {
  /** this endpoint is used to generate shared secret for session */
  KeyExchange(request: SessionKeyExchangeRequest): Promise<SessionKeyExchangeResponse>;
  /** this endpoint ensures that generated shared secret is correct between server and client */
  CheckChallenge(request: ChallengeRequest): Promise<ChallengeResponse>;
  /**
   * this endpoint is used to register app specific hash that would be used
   * with the sessions initiated with the app
   */
  RegisterApp(request: RegisterAppRequest): Promise<RegisterAppResponse>;
  /**  */
  RequestOtp(request: RequestOTPRequest): Promise<RequestOTPResponse>;
  /**  */
  CheckOtp(request: CheckOtpRequest): Promise<CheckOtpResponse>;
  RegisterUserSession(request: RegisterUserSessionRequest): Promise<RegisterUserSessionResponse>;
  GetBusinessLanding(
    request: GetBusinessWebLandingInformationRequest,
  ): Promise<GetBusinessWebLandingInformationResponse>;
  RegisterPwaSession(request: GetPwaSessionRequest): Promise<GetPwaSessionResponse>;
  GetRedirectUrl(request: GetRedirectUrlRequest): Promise<GetRedirectUrlResponse>;
  GetKeycloakLoginToken(request: KeycloakUserLoginRequest): Promise<KeycloakUserLoginResponse>;
  KeycloakUserLogout(request: KeycloakUserLogoutRequest): Promise<KeycloakUserLogoutResponse>;
}

export const SessionServiceServiceName = "ir.uid.service.SessionService";
export class SessionServiceClientImpl implements SessionService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || SessionServiceServiceName;
    this.rpc = rpc;
    this.KeyExchange = this.KeyExchange.bind(this);
    this.CheckChallenge = this.CheckChallenge.bind(this);
    this.RegisterApp = this.RegisterApp.bind(this);
    this.RequestOtp = this.RequestOtp.bind(this);
    this.CheckOtp = this.CheckOtp.bind(this);
    this.RegisterUserSession = this.RegisterUserSession.bind(this);
    this.GetBusinessLanding = this.GetBusinessLanding.bind(this);
    this.RegisterPwaSession = this.RegisterPwaSession.bind(this);
    this.GetRedirectUrl = this.GetRedirectUrl.bind(this);
    this.GetKeycloakLoginToken = this.GetKeycloakLoginToken.bind(this);
    this.KeycloakUserLogout = this.KeycloakUserLogout.bind(this);
  }
  KeyExchange(request: SessionKeyExchangeRequest): Promise<SessionKeyExchangeResponse> {
    const data = SessionKeyExchangeRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "KeyExchange", data);
    return promise.then((data) => SessionKeyExchangeResponse.decode(_m0.Reader.create(data)));
  }

  CheckChallenge(request: ChallengeRequest): Promise<ChallengeResponse> {
    const data = ChallengeRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CheckChallenge", data);
    return promise.then((data) => ChallengeResponse.decode(_m0.Reader.create(data)));
  }

  RegisterApp(request: RegisterAppRequest): Promise<RegisterAppResponse> {
    const data = RegisterAppRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RegisterApp", data);
    return promise.then((data) => RegisterAppResponse.decode(_m0.Reader.create(data)));
  }

  RequestOtp(request: RequestOTPRequest): Promise<RequestOTPResponse> {
    const data = RequestOTPRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RequestOtp", data);
    return promise.then((data) => RequestOTPResponse.decode(_m0.Reader.create(data)));
  }

  CheckOtp(request: CheckOtpRequest): Promise<CheckOtpResponse> {
    const data = CheckOtpRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CheckOtp", data);
    return promise.then((data) => CheckOtpResponse.decode(_m0.Reader.create(data)));
  }

  RegisterUserSession(request: RegisterUserSessionRequest): Promise<RegisterUserSessionResponse> {
    const data = RegisterUserSessionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RegisterUserSession", data);
    return promise.then((data) => RegisterUserSessionResponse.decode(_m0.Reader.create(data)));
  }

  GetBusinessLanding(
    request: GetBusinessWebLandingInformationRequest,
  ): Promise<GetBusinessWebLandingInformationResponse> {
    const data = GetBusinessWebLandingInformationRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetBusinessLanding", data);
    return promise.then((data) => GetBusinessWebLandingInformationResponse.decode(_m0.Reader.create(data)));
  }

  RegisterPwaSession(request: GetPwaSessionRequest): Promise<GetPwaSessionResponse> {
    const data = GetPwaSessionRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RegisterPwaSession", data);
    return promise.then((data) => GetPwaSessionResponse.decode(_m0.Reader.create(data)));
  }

  GetRedirectUrl(request: GetRedirectUrlRequest): Promise<GetRedirectUrlResponse> {
    const data = GetRedirectUrlRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetRedirectUrl", data);
    return promise.then((data) => GetRedirectUrlResponse.decode(_m0.Reader.create(data)));
  }

  GetKeycloakLoginToken(request: KeycloakUserLoginRequest): Promise<KeycloakUserLoginResponse> {
    const data = KeycloakUserLoginRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetKeycloakLoginToken", data);
    return promise.then((data) => KeycloakUserLoginResponse.decode(_m0.Reader.create(data)));
  }

  KeycloakUserLogout(request: KeycloakUserLogoutRequest): Promise<KeycloakUserLogoutResponse> {
    const data = KeycloakUserLogoutRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "KeycloakUserLogout", data);
    return promise.then((data) => KeycloakUserLogoutResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
